import { LevelManager } from '../game/LevelManager';
import { Config } from '../core/Config';

/**
 * UI component for displaying level and wave information
 */
export class LevelUI {
  private element: HTMLElement;
  private levelManager: LevelManager;
  private lastLevelNumber: number = 0;
  private lastWaveNumber: number = 0;
  private lastCountdown: number = 0;
  private lastActiveToasterCount: number = 0;
  
  constructor(levelManager: LevelManager) {
    this.levelManager = levelManager;
    
    console.log('LevelUI: Initializing UI component');
    
    // Create UI element
    this.element = this.createUIElement();
    
    // Add to DOM
    document.body.appendChild(this.element);
    
    console.log('LevelUI: Element created and added to DOM');
  }
  
  /**
   * Create the UI element
   */
  private createUIElement(): HTMLElement {
    const element = document.createElement('div');
    
    // Set ID for potential styling
    element.id = 'level-ui';
    
    // Style the container
    element.style.position = 'absolute';
    element.style.top = '10px';
    element.style.left = '50%';
    element.style.transform = 'translateX(-50%)';
    element.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    element.style.color = 'white';
    element.style.padding = '10px 20px';
    element.style.borderRadius = '5px';
    element.style.fontFamily = 'Arial, sans-serif';
    element.style.fontSize = '18px';
    element.style.fontWeight = 'bold';
    element.style.textAlign = 'center';
    element.style.zIndex = '1000';
    element.style.minWidth = '200px';
    
    // Initial content
    element.innerHTML = 'Preparing Game...';
    
    // Hide if UI is disabled in config
    if (!Config.LEVEL_SYSTEM.ENABLE_UI) {
      element.style.display = 'none';
    }
    
    return element;
  }
  
  /**
   * Update the UI
   */
  public update(): void {
    // Get current level and wave info
    const levelNumber = this.levelManager.getCurrentLevelNumber();
    const totalLevels = this.levelManager.getTotalLevels();
    const waveNumber = this.levelManager.getCurrentWaveNumber();
    const totalWaves = this.levelManager.getTotalWavesInCurrentLevel();
    const countdown = Math.ceil(this.levelManager.getCountdownTime());
    const isWaveInProgress = this.levelManager.isWaveInProgress();
    
    // Get toaster counts for the current wave
    const activeToasters = this.levelManager.getActiveToasterCount();
    const totalToasters = this.levelManager.getTotalToastersForCurrentWave();
    
    // Only update DOM if values have changed
    if (this.lastLevelNumber !== levelNumber || 
        this.lastWaveNumber !== waveNumber || 
        this.lastCountdown !== countdown || 
        this.lastActiveToasterCount !== activeToasters) {
      
      // Format display message based on state
      let message = '';
      
      if (countdown > 0 && !isWaveInProgress) {
        // Countdown to next wave
        message = `Level ${levelNumber}/${totalLevels} - Wave ${waveNumber}/${totalWaves}<br>Starting in ${countdown}...`;
      } else if (isWaveInProgress) {
        // Wave in progress with toaster count
        message = `Level ${levelNumber}/${totalLevels} - Wave ${waveNumber}/${totalWaves}<br>Toasters: ${activeToasters}/${totalToasters}`;
      } else {
        // Level complete or between levels
        message = `Level ${levelNumber}/${totalLevels} Complete!`;
      }
      
      // Update the element
      this.element.innerHTML = message;
      
      // Store values to avoid unnecessary DOM updates
      this.lastLevelNumber = levelNumber;
      this.lastWaveNumber = waveNumber;
      this.lastCountdown = countdown;
      this.lastActiveToasterCount = activeToasters;
    }
  }
} 